import { SELECTEDTAB_INDEX } from '../selectedTab/constants';

export function getTabs(state) {
  return state.tabs;
}

export function getSelectedTabs(state, index) {
  const tabIndex = index !== undefined ? index : SELECTEDTAB_INDEX;
  return state.tabs[tabIndex];
}

export function getTabIndexById(state, tabId) {
  let indexRes;
  getTabs(state).find((tab, index) => {
    if (tab.id === tabId) {
      indexRes = index;
      return true;
    }
    return false;
  });
  return indexRes;
}
